export default "__VITE_ASSET__PF_hW5GF__"